import { ModuleTypePageTitle } from '@/enums/axiom-report.enum'
import { Box } from '@mui/material'
import React, { ReactElement } from 'react'
import StaticReportsLayout from './StaticReportsLayout'

export const PortfolioOptimizationLayout: React.FC<{
  children: ReactElement
}> = ({ children }) => {
  return (
    <StaticReportsLayout title={ModuleTypePageTitle.PORTFOLIO_OPTIMIZATION}>
      <Box display='grid' height='calc(100vh - 100px)' overflow='hidden'>
        <Box display='grid' overflow='auto'>
          {children}
        </Box>
      </Box>
    </StaticReportsLayout>
  )
}
